var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-row"},[_c('img',{staticClass:"title-img-left",attrs:{"src":require("@/assets/member/heng_right.png"),"alt":""}}),_c('div',[_vm._t("default")],2),_c('img',{staticClass:"title-img-right",attrs:{"src":require("@/assets/member/heng_right.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }